import React from 'react';
import Box from '@mui/material/Box';

const Layout = ({children, ...props}) => {
  return (
    <Box
      {...props}
      display="flex"
      flex={1}
      minWidth={0}
      padding="2rem"
      bgcolor="tertiary200"
      sx={{padding: {xs: 0, sm: '1rem', md: '2rem'}}}>
      <Box
        display="flex"
        flex={1}
        minWidth={0}
        width="100%"
        position="relative"
        bgcolor="white"
        flexDirection="column"
        borderRadius="1rem"
        sx={{borderRadius: {xs: 0, sm: '1rem'}, overflowX: 'hidden'}}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
